module.exports = __webpack_public_path__ + "static/media/todayTime.84d70f0a.svg";